import React from 'react';
export function Footer() {
  return <footer className="max-w-3xl mx-auto text-center" data-id="element-188">
      <div className="text-[#00C853] text-2xl font-black tracking-widest mb-4" data-id="element-189">
        🇮🇹 PROFEPACK™
      </div>
      <p className="text-gray-400 text-sm leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-190">
        El sistema de enseñanza N°1 para docentes de Italiano de secundaria e
        institutos en Argentina.
      </p>
      <p className="text-gray-400 text-sm italic mb-6 font-bold" data-id="element-191">
        Porque enseñar Italiano no debería costarte todos los domingos del año.
      </p>

      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-300 mb-6" data-id="element-192">
        <span data-id="element-193">📧 soporteprofepack@gmail.com</span>
        <span className="hidden sm:inline" data-id="element-194">•</span>
        <span data-id="element-195">📲 @profepack</span>
        <span className="hidden sm:inline" data-id="element-196">•</span>
        <span data-id="element-197">🌐 www.profepack.com</span>
      </div>

      <div className="h-px bg-[#00C853]/20 mb-6" data-id="element-198" />
      <p className="text-gray-400 text-xs mb-2" data-id="element-199">
        © ProfePack™ 2026 — Todos los derechos reservados.
      </p>
      <p className="text-gray-500 text-xs mb-6" data-id="element-200">
        Prohibida la reproducción y redistribución sin autorización expresa.
      </p>
      <p className="text-gray-500 text-xs font-bold tracking-widest" data-id="element-201">
        🇮🇹 "Il prossimo domenica può essere diversa."
        <br data-id="element-202" />
        "El próximo domingo puede ser diferente."
      </p>
    </footer>;
}